import { useLocation } from '@tanstack/react-router';
import { Formik } from 'formik';

import { translate } from '../../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../../common/hooks/useDocumentTitle';
import { useRole } from '../../../common/hooks/useRole';
import type { PriceCompareFormValues } from '../types/PriceCompareFormValues';
import { createPriceCompareItem } from '../utils/createPriceCompareItem';
import { createPriceComparePort } from '../utils/createPriceComparePort';

import { CompareOverviewForm } from './CompareOverviewForm';

export const CompareOverview = () => {
    useDocumentTitle(translate('compare.title'));

    const role = useRole();
    const location = useLocation();
    const initialVesselId = location.state?.vesselId;
    const companyIds = role.getCompanies().map((company) => company.id);
    const customerId = role.isOneCompanyUser() ? companyIds[0] : location.state?.customerId;

    const initialValues: PriceCompareFormValues = {
        items: [createPriceCompareItem()],
        portInformation: [createPriceComparePort()],
        customerId: customerId ?? '',
        vesselId: initialVesselId ?? '',
    };

    return (
        <Formik<PriceCompareFormValues> key={initialVesselId} initialValues={initialValues} onSubmit={() => undefined}>
            <CompareOverviewForm />
        </Formik>
    );
};
